import React from 'react';
import TableCell from '@material-ui/core/TableCell';

function SummaryRow({ data }) {
    const reasonsCount = data.reduce((sum, row) => sum + ((row.amendmentReasons && row.amendmentReasons.length) || 0), 0);
    return (
        <>
            <TableCell />
            <TableCell />
            <TableCell>Total reason count: {reasonsCount}</TableCell>
        </>
    );
}

export default SummaryRow;